"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricRefreshTime = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var MetricRefreshTime = function (props) {
    return (React.createElement("div", { style: lastUpdatedStyle, "aria-label": Localize_1.Messages.ariaLabelLastRefresh() }, props.lastRefreshedTimestamp
        ? (0, metrics_engine_1.lastRefreshedAbsoluteFormatter)(props.lastRefreshedTimestamp)
        : Localize_1.Messages.notUpdated()));
};
exports.MetricRefreshTime = MetricRefreshTime;
var Colors = widgets_1.TabStyles.Colors;
var lastUpdatedStyle = {
    color: Colors.L9,
    fontSize: '12px',
};
//# sourceMappingURL=MetricRefreshTime.js.map